import { render } from "./SignupValidationDialog.vue?vue&type=template&id=615f986a"
import script from "./SignupValidationDialog.vue?vue&type=script&lang=js"
export * from "./SignupValidationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__